<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none">
    <path
      stroke-width="3"
      d="M7.906 0v10.165M.102 5.44c3.029.188 9.98 2.41 13.553 9.788"
    />
    <path stroke-width="3" d="M15.898 5.44c-3.029.188-9.98 2.41-13.553 9.788" />
  </svg>
</template>
